module.exports = _.isDate;


//////////////////
// WEBPACK FOOTER
// external "_.isDate"
// module id = 607
// module chunks = full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile widget/widget dashboard/dashboard business-manager/video-library-page